export default __webpack_public_path__ + "static/media/signup.a451835a.png";